import React, { FC, useContext, useState, useEffect } from 'react';
import Popover from '@glu/popover-react';
import { getMessage } from 'api/notifications/service';
import useLocale from 'components/useLocale';

// Components
import DangerousContent from 'components/dangerousContent/DangerousContent';
import { AppConfigContext } from 'components/appConfig/AppConfig';
import { LOGIN_HELP } from 'constants.js';

type Props = {
  className?: string;
};

const LoginHelpMessage: FC<Props> = ({ className }) => {
  const locale = useLocale();

  const [helpContent, setHelpContent] = useState();
  const { isMobile } = useContext(AppConfigContext);
  useEffect(() => {
    getMessage({ service: LOGIN_HELP })
      .toPromise()
      .then(({ data = {} }) => {
        if (data && data.message) {
          setHelpContent(data.message);
        }
      });
  }, []);

  if (!helpContent || isMobile) {
    return null;
  }

  return (
    <Popover
      placement="top"
      title={locale['login.contactUs']}
      content={<DangerousContent content={helpContent} />}
    >
      <button
        className={`btn btn-link ${className}`}
        type="button"
        data-qa="login-help-message-button"
      >
        {locale['logon.help']}
      </button>
    </Popover>
  );
};

export default LoginHelpMessage;
